import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    component: ()=> import('@/views/s1.vue')
  },
  {
    path:'/web',
    component: ()=> import('@/views/WebCrawlersView.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
